/** Google Fonts allowlist — keep in sync with backend/brand_store.py */
export const GOOGLE_FONTS = [
  { label: "Outfit", value: '"Outfit", system-ui, sans-serif', family: "Outfit:wght@400;500;600;700" },
  { label: "DM Sans", value: '"DM Sans", system-ui, sans-serif', family: "DM Sans:wght@400;500;600;700" },
  { label: "Inter", value: '"Inter", system-ui, sans-serif', family: "Inter:wght@400;500;600;700" },
  { label: "Poppins", value: '"Poppins", system-ui, sans-serif', family: "Poppins:wght@400;500;600;700" },
  { label: "Merriweather", value: '"Merriweather", Georgia, serif', family: "Merriweather:wght@400;700" },
  { label: "Playfair Display", value: '"Playfair Display", Georgia, serif', family: "Playfair+Display:wght@400;600;700" },
  { label: "Roboto Mono", value: '"Roboto Mono", ui-monospace, monospace', family: "Roboto+Mono:wght@400;600" },
];

export function googleFontsHref(labels = []) {
  const families = [];
  GOOGLE_FONTS.forEach((row) => {
    if (labels.includes(row.label) && !families.includes(row.family)) {
      families.push(row.family);
    }
  });
  if (!families.length) return "";
  return `https://fonts.googleapis.com/css2?${families.map((f) => `family=${f}`).join("&")}&display=swap`;
}

export function fontCssForLabel(label) {
  const row = GOOGLE_FONTS.find((f) => f.label === label);
  return row?.value || '"DM Sans", system-ui, sans-serif';
}
